<!-- <p>
  Report
</p> -->
<section id="reportsection" style="background-color: white; " class="page-section swiper-slide typo-light" data-hash="index">
  <div class="min-vh-h100 w100 flex-cc pd-t-100" data-ckav-sm="pd-tb-large"  >
 
      <div class="innerwrapper w100">
          <div class="container" >
              <div class="row">
                <ng-container *ngIf="this.isLogin">
                  <!-- <button onclick="exportX()"> Export</button> -->
                  <h3 style="margin-bottom: 30px; width: 100%; color: black; text-align: center;">NA AGENT REGISTER REPORT</h3>
                  <table datatable  style="max-height: calc(100vh- 30vh);" [dtOptions]="dtOptions" class="row-border hover">
                    <!-- <thead>
                      <tr>
                        <th>Agent Code</th>
                        <th>Agent Name</th>
                        <th>Area Code</th>
                        <th>Birthday</th>
                        <th>Mobile Phone</th>
                        <th>Created On</th>
                       
                      </tr>
                    </thead>
                    <tbody>
                     <tr *ngFor="let group of list">
                           <td>{{group.agentCode}}</td>
                           <td>{{group.agentName}}</td>
                           <td>{{group.areaCode}}</td>
                           <td>{{group.birthday | date: 'dd-MM-yyyy'}}</td>
                           <td>{{group.mobilePhone}}</td>
                           <td>{{group.createdOn | date: 'dd-MM-yyyy'}}</td>
                          
                       </tr>
                    </tbody> -->
                  </table>
                
                </ng-container>
                <ng-container *ngIf="!this.isLogin">
                  <div class="col-lg-12" >
                    <h3 class="title fs60 lh-1 f-1 mr-b-40" data-ckav-sm="fs30 mr-b-30" style="    font-size: 32px;
                    text-align: center;
                    color: #9B6164;">LOGIN</h3>
                      <!-- <h2 style="text-align: center; margin-bottom: 30px;"> ĐIỂM NỔI BẬT</h2> -->
                     
                    <form  class="form-widget align-l" novalidate="novalidate" data-ckav-sm="w100">
                        <div class="field-wrp mr-b-40">
                            <!-- <input type="hidden" name="to" value="c.kav.art@gmail.com"> -->

                            <div class="row gt10">
                                <div class="col-md-6 offset-md-3">
                                    <div class="form-group">

                                        <input #txtUserName class="form-control   bb" data-label="UserName" required="" data-msg="Vui Long Nhap User Name" type="text" name="name" placeholder="User Name" aria-required="true">
                                    </div>
                                </div>
                                <div class="col-md-6 offset-md-3">
                                  <div class="form-group">
                                      <input type="password" #txtPassword class="form-control   bb" data-label="Password" required="" data-msg="Vui Long Nhap Password"  name="Password" placeholder="Password" aria-required="true">
                                  </div>
                              </div>
                               
                            </div>
                             
                        </div>
                        <div class=" row" style="text-align: right">
                          <button type="submit" class="btn solid btn-default txt-upper round mr-auto fs20" 
                          (click)="login(txtUserName.value, txtPassword.value)"
                          ><i class="fa fa-envelope-o"></i> Login</button>

                        </div>
                    </form>
                    
                </div>
                  <!-- <form #loginForm="ngForm" (ngSubmit)="login()">
                      
                      <h2 class="title">{{'Welcome'}} </h2>
                      <div class="input-div one" [ngClass]="isNameFocus ? 'focus' : 'blur'">
                          <div class="i">
                              <i class="fas fa-user"></i>
                
                          </div>
                          <div class="div">
                              <h5>{{'UserName'}}</h5>
                              <input type="text" class="input" required [(ngModel)]="model.username" name="username" id="txtName" #txtName (focus)="onFocus(txtName)" (focusout)="onFocus(txtName)">
                          </div>
                      </div>
                      <div class="input-div pass" [ngClass]="isPassFocus ? 'focus' : 'blur'">
                          <div class="i">
                              <i class="fas fa-lock"></i>
                
                          </div>
                          <div class="div">
                              <h5>{{'Password' }}</h5>
                              <input type="password" class="input" id="txtPassword" name="password" required [(ngModel)]="model.password" #txtPassword (focus)="onFocus(txtPassword)" (focusout)="onFocus(txtPassword)">
                          </div>
                      </div>
                      <a href="#">{{'Forgot Password'}}?</a>
                      <input type="submit" class="btn" value="Login">
                  </form> -->
                </ng-container>
              </div>
          </div>
      </div>
  </div>
</section>

  <!-- "node_modules/jquery/dist/jquery.js", -->